import React from "react";
import { useSelector } from "react-redux";
import {
	makeSelectSumByFormulaId,
	selectTotalFundingDifference,
	selectTotalFundingSource,
	selectTotalNbv,
} from "reducers";
import NumberDisplay from "components/NumberDisplay";

export const TotalNbv = () => {
	const value = useSelector(selectTotalNbv);
	return (
		<NumberDisplay
			number={value}
			style={{ fontWeight: 600, marginRight: 12 }}
		/>
	);
};

export const TotalCost = () => {
	const selector = makeSelectSumByFormulaId("formulaId");
	const value = useSelector(selector);
	return <NumberDisplay number={value} style={{ fontWeight: 600 }} />;
};

export const TotalOngoing = () => {
	const selector = makeSelectSumByFormulaId("ongoingTotal");
	const value = useSelector(selector);
	return <NumberDisplay number={value} style={{ fontWeight: 600 }} />;
};

export const TotalFundingSource = () => {
	const value = useSelector(selectTotalFundingSource);
	return (
		<NumberDisplay
			number={value}
			style={{ fontWeight: 600, width: "100%" }}
		/>
	);
};

export const TotalFundingDifference = () => {
	const value = useSelector(selectTotalFundingDifference);
	return (
		<NumberDisplay
			number={value}
			style={{ fontWeight: 600, width: "100%" }}
		/>
	);
};
